export const DomainTypeId = '72af0602-1321-4897-8299-f507480b2bb8';
export const DomainAddonsTypeId = 'b3d86a1d-9db3-4f69-bd54-c132808856b1';
export const Base44DomainTypeId = '76cb0c0d-4131-4d3b-9bc0-2ddc2b78706f';
export const Base44DomainAddonsTypeId = 'c5a66786-9a38-45af-a07f-51dc90087a27';
export const DomainProductType = {
  Wix: 'Wix',
  Base44: 'Base44'
};
export const DEFAULT_DOMAIN_PRODUCT_TYPE = 'Wix';
const DomainProductTypeIdByDomainProductType = {
  Wix: DomainTypeId,
  Base44: Base44DomainTypeId
};
const DomainAddonsTypeIdByDomainProductType = {
  Wix: DomainAddonsTypeId,
  Base44: Base44DomainAddonsTypeId
};
export const getDomainProductTypeId = function (domainProductType) {
  if (domainProductType === void 0) {
    domainProductType = DEFAULT_DOMAIN_PRODUCT_TYPE;
  }
  return DomainProductTypeIdByDomainProductType[domainProductType] ?? DomainTypeId;
};
export const getDomainAddonsTypeId = function (domainProductType) {
  if (domainProductType === void 0) {
    domainProductType = DEFAULT_DOMAIN_PRODUCT_TYPE;
  }
  return DomainAddonsTypeIdByDomainProductType[domainProductType] ?? DomainAddonsTypeId;
};
export const Base44AddonProductFamilies = {
  'a27c05e9-5880-46aa-9574-1ee377b0720e': 'privacy_and_dnssec',
  '99c36be8-a6cd-49cb-bfe8-9d54a4a5abf5': 'public',
  '95c631d8-0263-4b8d-b01a-c2c2c9519a1c': 'privacy'
};
export const AddonProductFamilies = {
  'a86d552f-96dc-4bc1-b307-8719d8c82d7a': 'privacy_and_dnssec',
  '494e15b1-a4ea-473c-81e5-23417ca783fa': 'public',
  '97bf8ed9-2353-4a97-97a8-0dd313b2d7be': 'privacy'
};
export const AddonProductFamiliesByDomainProductType = {
  Wix: AddonProductFamilies,
  Base44: Base44AddonProductFamilies
};
//# sourceMappingURL=domainProducts.js.map